export const UPDATE_FORM = "UPDATE_HIERARCHY_FORM";
export const RESET_FORM = "RESET_HIERARCHY_FORM";

export const updateHierarchyReport = (formData) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_FORM,
      payload: formData,
    });
  };
};

export const resetHierarchyReport = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_FORM,
    });
  };
};
